import { TopbarStructure } from "../store";
import { TOPBAR } from "../actions-constants/topbar.constants";

const initialTopbar:TopbarStructure = new TopbarStructure

export function topbarReducer(topbar:TopbarStructure = initialTopbar,action):TopbarStructure {
    switch (action.type) {
        case TOPBAR.SHOW_SEARCH_BUTTON:
            return {...topbar,showSearchButton: action.show}
        case TOPBAR.SHOW_SEARCH_BAR:
            return {...topbar,showSearchBar: action.show}
        case TOPBAR.SHOW:
            return {...topbar,show: action.show}
        case TOPBAR.HAS_NAV_MENU:
            return {...topbar,hasNavMenu: action.has}
        case TOPBAR.SET_NAV_LIST:
            return {...topbar,navList: action.navList}
        case TOPBAR.SET_REFRESH_FUNCTION:
            return {...topbar,refreshFunction: action.refreshFunction}
        case TOPBAR.SET_BUTTONS:
            return {...topbar,buttons: action.buttons}
        case TOPBAR.SET_MENU_ITEMS:
            return {...topbar,menuItems: action.menuItems}
        case TOPBAR.SET_SEARCH_PLACE_HOLDER:
            return {...topbar,searchPlaceHolder: action.searchPlaceHolder}
        case TOPBAR.SET_SEARCH_TEXT:
            return {...topbar,searchText: action.searchText}
        case TOPBAR.SHOW_BACK_BUTTON:
            return {...topbar,showBackButton: action.show}
        case TOPBAR.SHOW_HOME_BUTTON:
            return {...topbar,showHomeButton: action.show}
        default:
            return topbar
    }
}